__turbopack_context__.v({
  "container": "SettingRowCollapsible-module__kirj0q__container",
  "content": "SettingRowCollapsible-module__kirj0q__content",
});
